// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 94) return "static/chunks/94-2afb4e7aae34a01a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"84":"7808be146fbc13e6","453":"402a895b3a100492","725":"e85c522186cd687f"}[chunkId] + ".js";
};